import React, { useEffect, useState } from "react";
import axiosInstance from "../../interceptor/axiosInstance";
import { useNavigate } from "react-router-dom";

const ManageOrganisation = () => {
    const [orgList, setOrgList] = useState([]); // State for storing ticket list
    const [loading, setLoading] = useState(true); // Loading state
    const [error, setError] = useState(null); // Error state
    const navigate = useNavigate();


    useEffect(() => {
        const fetchOrganisation = async () => {
            try {
                const response = await axiosInstance.get(`/org/list`);
                setOrgList(response.data); // Set the ticket list to state
            } catch (err) {
                setError("Error fetching data"); // Handle error if request fails
            } finally {
                setLoading(false); // Stop loading after the request is complete
            }
        };

        fetchOrganisation();  // Trigger the fetch function
    }, []);

    // Handle loading and error states
    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    const handleRowClick = (org_id) => {
        navigate(`/manage-organisation/${org_id}`);
    };

    return (
        <div className="d-flex flex-column min-vh-100">
            <main className="flex-fill">
                <div>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr className="tbl-header-color">
                                <th style={styles.headerCell}>Name</th>
                                <th style={styles.headerCell}>Organisation Name</th>
                                <th style={styles.headerCell}>Email</th>
                                <th style={styles.headerCell}>Website URL</th>
                                <th style={styles.headerCell}>Code</th>
                                <th style={styles.headerCell}>Mobile Number</th>
                                <th style={styles.headerCell}>Status</th>
                                <th style={styles.headerCell}>Created At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orgList.map((org) => (
                                // <tr key={org.queue_id} className="row-selection" onClick={() => handleRowClick(org.org_id)}>
                                <tr key={org.queue_id} className="row-selection">
                                    <td style={styles.cell}>{org.name}</td>
                                    <td style={styles.cell}>{org.organisation_name}</td>
                                    <td style={styles.cell}>{org.email}</td>
                                    <td style={styles.cell}>{org.website_url}</td>
                                    <td style={styles.cell}>{org.organisation_code}</td>
                                    <td style={styles.cell}>{org.mobile_number}</td>
                                    <td style={styles.cell}>{org.status? 'Active': 'Inactive'}</td>
                                    <td style={styles.cell}>{new Date(org.created_at).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </main>
        </div>
    );
};

const styles = {
    headerCell: {
      border: "1px solid #ddd",
      padding: "8px",
      textAlign: "left",
      fontWeight: "bold",
    },
    cell: {
      border: "1px solid #ddd",
      padding: "8px",
      textAlign: "left",
    },
    row: {
      ':hover': { backgroundColor: '#08176a' },
      backgroundColor: "#fff",
      cursor: "pointer",
      // height: "20px"
    }
  };

export default ManageOrganisation;

